/* eslint-disable jsx-a11y/anchor-is-valid */
import { Accordion, AccordionTab } from 'primereact/accordion';
import React, { useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import useEffectOnce from 'src/hooks/useEffectOnce';
import { POST } from 'src/services';
import { urlPreguntasFrecuentesPtp } from 'src/services/urls';

const ModalPtpPreguntas = () => {
  const [data, setData] = useState(null);

  const [show, setModalShow] = useState(false);

  const close = () => {
    setModalShow(false);
  };

  const getInfoPtp = async () => {
    if (!data) {
      const res = await POST(urlPreguntasFrecuentesPtp);

      if (res.data) {
        setData(res.data.data);
      }
    }
  };

  useEffectOnce(() => {
    getInfoPtp();
  });

  if (!!!data) {
    return null;
  }
  const { titulos, preguntasFrecuentes } = data;
  return (
    <>
      <a className="preguntas_frecuentes text-center" onClick={() => setModalShow(!show)}>
        Preguntas frecuentes
      </a>
      <Modal
        show={show}
        onHide={close}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header>
          <Modal.Title id="contained-modal-title-vcenter">
            <h5 className="modal__preguntas__titulo font-weight-bold">{titulos.titulo}</h5>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {titulos.textos.map((texto, index) => (
            <div dangerouslySetInnerHTML={{ __html: texto }} key={index} />
          ))}
          <Accordion>
            {preguntasFrecuentes.map(({ pregunta, respuesta }, index) => (
              <AccordionTab header={pregunta} key={index}>
                <div dangerouslySetInnerHTML={{ __html: respuesta }} key={index} />
              </AccordionTab>
            ))}
          </Accordion>
        </Modal.Body>
        <Modal.Footer>
          <Button className="modal__preguntas__btn__cerrar" onClick={close}>
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ModalPtpPreguntas;
